<template>
  <div class="pb-16">
    <div class="card-carousel-wrapper pb-6">
      <div class="flex justify-center items-center cursor-pointer mr-4 lg:mr-8 text-4xl md:border border-honey rounded-full h-16 w-16" @click="moveCarousel(-1)"><i class="fal fa-chevron-left"></i></div>
      <div class="card-carousel w-3/4 xl:w-2/3">
        <div class="card-carousel--overflow-container overflow-y-hidden">
          <div class="card-carousel-cards" :style="{ transform: 'translateX' + '(' + currentOffset + 'px' + ')'}">
            <div class="card-carousel--card relative w-full md:w-1/3 flex-shrink-0" v-for="entry in reversed_entries">
              <img v-bind:src="entry.image.url" v-bind:alt="entry.image.alt ? entry.image.alt : 'Carousel Card Image'" class="object-cover w-full h-48 md:h-64 lg:h-72 xl:h-96" />
              <a v-if="entry.link" v-bind:href="entry.link" target="_blank" rel="noreferrer" aria-label="entry.link"
                 class="absolute top-0 left-0 w-full h-48 md:h-64 lg:h-72 xl:h-96">
                  <div id="image-gallery-hover-container" class="absolute top-0 left-0 w-full h-48 md:h-64 lg:h-72 xl:h-96 lg:hover:bg-white lg:hover:bg-opacity-70 z-20 cursor-pointer" @click="popup(entry)">
                    <div class="absolute top-1/3 lg:top-1/5 left-0 text-center font-Playfair text-xl sm:text-3xl w-full">
                        <span class="fa-stack fa-3x">
                            <i class="fas fa-square-full fa-stack-2x text-black"></i>
                            <i v-if="imagePopup" class="fal fa-plus fa-stack-1x text-white"></i>
                            <i v-else class="fal fa-search fa-stack-1x text-white"></i>
                        </span>
                    </div>
                  </div>
                </a>
                <!-- If no link, use container without surrounding anchor !-->
                <div v-else id="image-gallery-hover-container" class="absolute top-0 left-0 w-full h-48 md:h-64 lg:h-72 xl:h-96 lg:hover:bg-white lg:hover:bg-opacity-70 z-20 cursor-pointer" @click="popup(entry)">
                  <div class="absolute top-1/3 lg:top-1/5 left-0 text-center font-Playfair text-xl sm:text-3xl w-full">
                      <span class="fa-stack fa-3x">
                          <i class="fas fa-square-full fa-stack-2x text-black"></i>
                          <i v-if="imagePopup" class="fal fa-plus fa-stack-1x text-white"></i>
                          <i v-else class="fal fa-search fa-stack-1x text-white"></i>
                      </span>
                  </div>
                </div>
                <div class="card-carousel--card--footer">
                  <div class="font-extrabold text-lg text-black cursor-default">{{ entry.title }}</div>
                  <div class="text-sm cursor-default">{{ entry.details }}</div>
<!--                  they mentioned to take this off in some but not all passages so leaving it comment it out for now-->
<!--                  <div v-if="link"><a v-bind:href="entry.link" target="_blank" rel="noreferrer">More +</a></div>-->
                </div>
              </div>
            </div>
          </div>
        </div>
      <div class="flex justify-center items-center cursor-pointer ml-4 lg:ml-8 text-4xl md:border border-honey rounded-full h-16 w-16" @click="moveCarousel(1)"><i class="fal fa-chevron-right"></i></div>
      <modal v-if="imagePopup" ref="cardmodal" class="absolute">
        <template #title>
          {{ this.popupTitle }}
        </template>
        <template #default="slotData">
            <div class="sm:flex text-black space-x-4 text-left" v-cloak>
                <div class="flex-1">
                    <carousel :count="imageItems.length" :has-images="true" :starting-index="slotData.slotData">
                        <template v-for="(entry, index) in imageItems" v-slot:[`item-`+index]>
                            <img v-bind:src="entry.url" alt="entry.alt" class="w-full object-scale-down h-52 lg:h-96" />
                        </template>
                        <template v-for="(entry, index) in imageItems" v-slot:[`item-image-`+index]>
                            <img v-bind:src="entry.url" alt="entry.alt" class="w-48 h-32 object-cover" />
                        </template>
                    </carousel>
                </div>
            </div>
        </template>
      </modal>
      <modal v-if="detailsPopup" ref="detailsmodal" class="absolute top-1/3">
        <template #default="slotData">
          <div class="grid grid-cols-1 md:grid-cols-2 gap-6">
            <div class="col-span-1">
              <p class="text-2xl font-bold font-Playfair mb-4">{{ this.popupEntry.title }}</p>
              <p class="font-extrabold text-lg mb-1">{{ this.popupEntry.details }}</p>
              <p class="font-extrabold text-lg mb-6">{{ this.popupEntry.start_time }} - {{ this.popupEntry.end_time }}</p>
              <p v-if="popupEntry.musician_website" class="mb-4">Musician: <a v-bind:href="popupEntry.musician_website" target="_blank" rel="noreferrer" class="font-bold">{{ this.popupEntry.musician }}</a></p>
              <p v-else class="mb-4">Musician: {{ this.popupEntry.musician }}</p>
              <p class="mb-4">{{ this.popupEntry.content }}</p>
              <p class="italic">{{this.popupEntry.call_to_action}}
                <a v-bind:href="this.popupEntry.call_to_action_link" target="_blank" rel="noreferrer"><span class="font-bold underline">{{this.popupEntry.call_to_action_link_text}}</span></a>
                {{this.popupEntry.call_to_action_content}}
              </p>
            </div>
            <div class="col-span-1">
              <img v-bind:src="popupImage.url" alt="popupImage.alt" class="w-full object-contain" />
            </div>
          </div>
        </template>
      </modal>
    </div>
    <div v-if="monthDisplay" class="grid grid-cols-3 gap-2 md:flex justify-center mx-auto w-3/4 xl:w-2/3">
      <div class="inline-block mx-auto text-center font-bold text-gray-500 cursor-pointer" v-for="(item, index) in monthList" v-bind:class="{ ['text-honey'] : item.selected }" @click="jumpTo(index)">
        {{ item.display }}
      </div>
    </div>
  </div>
</template>

<script>
import modal from "./Modal";
import carousel from "./Carousel";
export default {
  name: 'MultiCarousel',
  components: { modal, carousel },
  data() {
    return {
      currentOffset: 0,
      items: [],
      imageItems: [],
      popupEntry: {},
      popupTitle: "",
      popupImage: {},
      monthList: [
        {
          display: "Jan 22",
          selected: false,
          empty: true,
        },
        {
          display: "Feb 22",
          selected: false,
          empty: true,
        },
        {
          display: "Mar 22",
          selected: false,
          empty: true,
        },
        {
          display: "Apr 22",
          selected: false,
          empty: true,
        },
        {
          display: "May 22",
          selected: false,
          empty: true,
        },
        {
          display: "Jun 22",
          selected: false,
          empty: true,
        },
        {
          display: "Jul 22",
          selected: false,
          empty: true,
        },
        {
          display: "Aug 22",
          selected: false,
          empty: true,
        },
        {
          display: "Sep 22",
          selected: false,
          empty: true,
        },
        {
          display: "Oct 22",
          selected: false,
          empty: true,
        },
        {
          display: "Nov 22",
          selected: false,
          empty: true,
        },
        {
          display: "Dec 22",
          selected: false,
          empty: true,
        }
      ],
      selectedMonth: 0,
    }
  },
  props: {
    link: {
      type: Boolean,
      default: false
    },
    current: {
      type: Boolean,
      default: false
    },
    reverse: {
      type: Boolean,
      default: true
    },
    entries: {
      type: Array,
      default: null
    },
    imagePopup: {
      type: Boolean,
      default: false
    },
    detailsPopup: {
      type: Boolean,
      default: false
    },
    monthDisplay: {
      type: Boolean,
      default: false
    },
    futureEventsOnly: {
      type: Boolean,
      default:false
    }
  },
  computed: {
    reversed_entries: function() {

      let filtered = (this.futureEventsOnly) ? this.entries.filter(this.eventFilter) : this.entries;

      if(this.reverse)
      {
        return filtered.reverse();
      }
      else
      {
        return filtered;
      }
    },
  },
  mounted() {
    var startingOffset = 0;
    if(!this.current){
      this.currentOffset = 0;
    }
    else {
      let currentDate = new Date();
      this.monthList[currentDate.getMonth()].selected = true;
      this.selectedMonth = currentDate.getMonth();
      var eventDate;

      for(var i = 0; i < this.reversed_entries.length; i++) {
        eventDate = new Date(this.reversed_entries[i].date);
        if(i == this.reversed_entries.length - 1) {
          startingOffset = i;
          this.currentOffset = startingOffset;
          break;
        }
        if(currentDate.getMonth() <= eventDate.getMonth()) {
          if(currentDate.getDate() <= eventDate.getDate()) {
            startingOffset = i;
            this.currentOffset = startingOffset;
            break;
          }
        } else if(currentDate.getTime() > eventDate.getTime()){
          continue;
        }
      }
    }
    for(var i = 0; i < this.reversed_entries.length; i++) {
      var eventDate = new Date(this.reversed_entries[i].date);
      var month = eventDate.getMonth();
      this.monthList[month].empty = false;
    }

    window.addEventListener('load', () => {
      this.currentOffset = -Math.abs((startingOffset) * this.getCardWidth());
    });
  },
  methods: {
    getCardWidth() {
      return this.$el.querySelector('.card-carousel--card').clientWidth;
    },
    moveCarousel(direction) {
      // Find a more elegant way to express the :style. consider using props to make it truly generic
      if (direction === 1 && !this.atEndOfList()) {
        this.currentOffset -= this.$el.querySelector('.card-carousel--card').clientWidth;
      } else if (direction === -1 && !this.atHeadOfList()) {
        this.currentOffset += this.$el.querySelector('.card-carousel--card').clientWidth;
      }
    },
    atEndOfList() {
      return this.currentOffset <= -Math.abs(this.$el.querySelector('.card-carousel--card').clientWidth * (this.reversed_entries.length - (this.$el.querySelector('.card-carousel').clientWidth / this.$el.querySelector('.card-carousel--card').clientWidth)));
    },
    atHeadOfList() {
      return this.currentOffset === 0;
    },
    popup(entry) {
      if(this.imagePopup) {
        // for(var image in entry.image)
        //   this.imageItems.push([image, entry.image[image]]);
        this.imageItems = entry.image;
        this.popupTitle = entry.title;
        this.$refs.cardmodal.open(0);
      }
      else if(this.detailsPopup) {
        this.popupEntry = entry;
        this.popupImage = entry.image;
        this.$refs.detailsmodal.open();
      }
      else {
        ;
      }
    },
    jumpTo(index) {
      var eventDate;
      this.monthList[this.selectedMonth].selected = false;
      this.monthList[index].selected = true;
      this.selectedMonth = index;
      var firstDate = new Date(this.reversed_entries[0].date);
      if(firstDate.getMonth() > index || firstDate.getMonth() == index) {
        this.currentOffset = 0;
        return;
      }
      for(var i = 0; i < this.reversed_entries.length; i++) {
        eventDate = new Date(this.reversed_entries[i].date);
        if(eventDate.getMonth() == index) {
          this.currentOffset = -Math.abs((i) * this.getCardWidth());
          return;
        }
        else if(eventDate.getMonth() < index) {
          this.currentOffset = -Math.abs((i) * this.getCardWidth());
        }
      }
    },
    eventFilter(e) {
      let eventDate = new Date(e.date);
      let currentDate = new Date();
      return currentDate <= eventDate;
    }
  }
};
</script>

<style>
body {
  background: #f8f8f8;
  color: #2c3e50;
}

.card-carousel-wrapper {
  display: flex;
  align-items: center;
  justify-content: center;
}

.card-carousel {
  display: flex;
  justify-content: center;

  &--overflow-container {
    overflow-x: hidden;
  }

  &--nav__left,
  &--nav__right {
    display: inline-block;
    width: 15px;
    height: 15px;
    padding: 10px;
    box-sizing: border-box;
    border-top: 2px solid #42b883;
    border-right: 2px solid #42b883;
    cursor: pointer;
    margin: 0 20px;
    transition: transform 150ms linear;
    &[disabled] {
      opacity: 0.2;
      border-color: black;
    }
  }
}

.card-carousel-cards {
  display: flex;
  transition: transform 150ms ease-out;
  transform: translatex(0px);

  .card-carousel--card {
    margin: 0 0px;
    cursor: pointer;
    background-color: #fff;
    z-index: 3;
    margin-bottom: 2px;

    &--footer {
      border-top: 0;
      padding: 7px 15px;

      p {
        padding: 3px 0;
        margin: 0;
        margin-bottom: 2px;
        user-select: none;

        &.tag {
          font-size: 11px;
          font-weight: 300;
          padding: 4px;
          background: rgba(40,44,53,.06);
          display: inline-block;
          position: relative;
          margin-left: 4px;

          &:before {
            content:"";
            float:left;
            position:absolute;
            top:0;
            left: -12px;
            width:0;
            height:0;
            border-color:transparent rgba(40,44,53,.06) transparent transparent;
            border-style:solid;
            border-width:8px 12px 12px 0;
        }
          &.secondary {
            margin-left: 0;
            border-left: 1.45px dashed white;
            &:before {
              display: none !important;
            }
          }

          &:after {
            content:"";
            position:absolute;
            top:8px;
            left:-3px;
            float:left;
            width:4px;
            height:4px;
            border-radius: 2px;
            background: white;
            box-shadow:-0px -0px 0px #004977;
          }
        }
      }
    }
  }
}
</style>